import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-theft-id',
  templateUrl: './theft-id.component.html',
  styleUrls: ['./theft-id.component.scss']
})
export class TheftIdComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
